<div class="thread" role="log" *transloco="let t">
  @for (message of messages(); track $index) {
    <div
      class="thread__message"
      [class.thread__message--own]="message.from === own()"
      [class.thread__message--supplier]="message.from === 'supplier'"
    >
      <div class="thread__meta">
        <strong>{{
          message.name || t(message.from === 'supplier' ? 'views.psa.inquiry_thread_supplier' : 'views.psa.inquiry_thread_requester')
        }}</strong>
        <span>{{ message.at | date: 'short' }}</span>
      </div>
      @if (message.text) {
        <div class="thread__text">{{ message.text }}</div>
      } @else if ($first && questionLabel()) {
        <div class="thread__text thread__text--label">{{ questionLabel() }}</div>
      }
    </div>
  }
</div>
